import { Dialog, DialogContent, DialogTitle } from '@mui/material';
import React from 'react';
import Icon from '../Icons/icon';
import classes from './customizedModalBase.module.scss';
import { customScroll } from 'styles/variables';
import colorsVars from 'styles/colors.module.scss';
import { useMobileStore } from 'store/mobile.store';
import scssVariables from 'styles/variables.module.scss';

const { modalBaseBackground, textColor, modalBaseBorderColor, white, black } = colorsVars;
const { mediaMobile } = scssVariables;

interface CustomizedModalProps {
    isModalOpen: boolean;
    handleModalClose: () => void;
    modalStyles?: Record<string, unknown>;
    isModalBlock?: boolean;
    rootStyles?: Record<string, unknown>;
    stickyLightTheme?: boolean;
    showTitle?: boolean;
    children: React.ReactNode;
}

export const CustomizedModalBase = ({
    isModalOpen,
    handleModalClose,
    children,
    modalStyles,
    isModalBlock = false,
    rootStyles,
    stickyLightTheme = false,
    showTitle = true,
}: CustomizedModalProps) => {
    const handleClose = () => {
        if (!isModalBlock) {
            handleModalClose();
        }
    };

    const isMobile = useMobileStore((state) => state.isMobile);

    return (
        <Dialog
            sx={{
                '.MuiDialog-paper': {
                    overflow: 'visible',
                    borderRadius: '2rem',
                    border: `solid 1px ${modalBaseBorderColor}`,
                    backgroundColor: stickyLightTheme ? white : modalBaseBackground,
                    padding: '8px',
                    color: stickyLightTheme ? black : textColor,
                    ...modalStyles,
                    [`@media (max-width:${mediaMobile})`]: {
                        overflow: 'auto',
                    },
                },
                '.MuiDialogContent-root': {
                    overflow: 'visible',
                    ...customScroll,
                    ...rootStyles,
                },
            }}
            onClose={handleClose}
            maxWidth={'xl'}
            open={isModalOpen}
            disableScrollLock
            transitionDuration={350}
            disableEscapeKeyDown={isModalBlock}
            closeAfterTransition={false}
            fullScreen={isMobile ?? false}
        >
            {showTitle && (
                <DialogTitle>
                    <div onClick={handleClose} id={'closeModalIcon'} className={classes.closeModalButton}>
                        <Icon name={'filter-x-icon'} size={'2.4rem'} />
                    </div>
                </DialogTitle>
            )}
            <DialogContent>{children}</DialogContent>
        </Dialog>
    );
};
